import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import React__default, { useRef, useState, useMemo, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import { richTextFromMarkdown } from '@contentful/rich-text-from-markdown';
import CustomRichText from '../../common/CustomRichText.js';

var CustomRichTextFromMarkdown = function CustomRichTextFromMarkdown(_ref) {
  var markdownString = _ref.markdownString,
    fallback = _ref.fallback;
  var mountedRef = useRef(true);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    document = _useState2[0],
    setDocument = _useState2[1];
  var doRichText = useMemo(function () {
    return function (markdownString, fallback) {
      return richTextFromMarkdown(markdownString, fallback).then(function (data) {
        if (!mountedRef.current) {
          return null;
        }
        setDocument(data);
        return data;
      });
    };
  }, [richTextFromMarkdown, setDocument]);
  useEffect(function () {
    doRichText(markdownString, fallback);
  }, [markdownString, doRichText]);
  useEffect(function () {
    return function () {
      mountedRef.current = false;
    };
  }, [mountedRef]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, document && /*#__PURE__*/React__default.createElement(CustomRichText, {
    document: document
  }));
};
CustomRichTextFromMarkdown.propTypes = {
  markdownString: PropTypes__default.string.isRequired,
  fallback: PropTypes__default.func
};

export { CustomRichTextFromMarkdown as default };
//# sourceMappingURL=CustomRichTextFromMarkdown.js.map
